import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Skip when it's just a language switch on the same base path.
    // The LanguageSwitcher sets a session flag so we can ignore that transition.
    const skip = sessionStorage.getItem("ecominarg:skipScroll");
    if (skip === "1") {
      sessionStorage.removeItem("ecominarg:skipScroll");
      return;
    }
    try {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    } catch (e) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;
